import React from 'react';

import { ReactComponent } from '../../assets/svg/people.svg';


export default () => <ReactComponent />;
